import React from "react";
import {
  Container,
  Header,
  Image,
  Button

} from "semantic-ui-react";
import DesignerImage from '../../../../images/grafix-banner/lifecycledesigner.svg';

class NoPlaybookPage extends React.Component {

  render() {
    return (

      <Container fluid className="pad_40">
        <Image src={DesignerImage} className="landingImage" size='large' centered={true} style={{ width: "300px" }} />
        <Header as='h3' icon textAlign='center'>
          <Header.Content >
            {this.props.landingMessage}
            <br /> <br /> <br />
          </Header.Content>
          <Header.Content className="clr-gray f_14" >
            Click to add your own Playbook &nbsp; &nbsp;
            <Button className="button-submit" size="tiny" onClick={this.props.displayNewPlaybookModal}>
              Add Playbook
            </Button>
          </Header.Content>
        </Header>
      </Container>



    );
  }
}
export default NoPlaybookPage;
